import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Editor from 'react-tinymce';

export default class Campaign extends Base {
    constructor(props) {
        super(props);
        this.state = {
            isOrganization: props.IsOrganization,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: !this.state.isOrganization,
            useIn: '',
            crmTeams: ''
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/campaign/get", {
            id: this.getCurrentFormId(),
            isOrganization: this.state.isOrganization,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e, status) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/campaign/save", {
            id: this.state.id,
            isOrganization: this.state.isOrganization,
            status: status,
            title: this.state.data.record.title,
            note: this.state.data.record.note,
            template: this.state.data.record.template,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات کمپین" : "افزودن کمپین جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">یادداشت</label>
                                            <input defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                    {this.state.data.record.service === 2 && <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label className="form-label required">متن پیام</label>
                                            <select defaultValue={this.state.data.record.template} onChange={e => this.state.data.record.template = e.target.value} autoComplete="off" type="text" className="form-control">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record.service === 1 && <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">الگوی متن ایمیل</label><span className="red">*</span>
                                            <Editor
                                                content={this.state.data.record.template}
                                                config={{
                                                    convert_urls: false,
                                                    images_upload_handler: (blobInfo, success, failure, progress) => {
                                                        fetch("/api/v1/campaign/upload/", {
                                                            method: "post",
                                                            body: JSON.stringify({ "pic": "data:image/jpeg;base64," + blobInfo.base64() }),
                                                            headers: {
                                                                'Content-Type': 'application/json'
                                                            }
                                                        })
                                                            .then(response => response.json())
                                                            .then(resualt => {
                                                                if (resualt.status == 1) success(resualt.path);
                                                                else failure(resualt.message);
                                                            })
                                                            .catch(err => {
                                                                failure("خطا در آپلود فایل")
                                                            });
                                                        //        this.setState({
                                                        //            picToCrop2: "data:image/jpeg;base64," + blobInfo.base64(),
                                                        //            editorUploaderSuccessCalback: success,
                                                        //            editorUploaderFailorCalback: failure
                                                        //        })
                                                    },
                                                    images_file_types: 'jpg,jpeg,png,webp',
                                                    automatic_uploads: false,
                                                    file_picker_types: 'image',
                                                    language: 'fa_IR',
                                                    directionality: 'rtl',
                                                    paste_as_text: true,
                                                    height: 250,
                                                    plugins: [
                                                        'code textcolor colorpicker image imagetools importcss table preview advlist media lists link autolink paste'
                                                    ],
                                                    toolbar: 'formatselect format code alignleft aligncenter alignright alignjustify rtl ltr forecolor backcolor table format image forecolor backcolor preview media numlist bullist link',
                                                    menubar: "tools insert file edit view format table",
                                                }}
                                                onChange={e => {
                                                    this.state.data.record.template = e.target.getContent()
                                                }}
                                            />
                                            <p>برای درج نام شخص در داخل الگو، از متغییر #name#  و برای درج آدرس ایمیل از متغییر #email# استفاده نمایید</p>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            {this.state.data.record.status === 1 && <button type="submit" onClick={e => this.save(e, 1)} className="btn btn-success">
                                ذخیره
                            </button>}
                            {this.state.data.record.status === 1 && <button type="submit" onClick={e => this.save(e, 2)} className="btn btn-danger">
                                ذخیره و شروع ارسال
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}